import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import sodium from 'libsodium-wrappers';
import './Auth.css';

const Register = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Initialize libsodium
      await sodium.ready;

      // Generate key pair
      const { publicKey, privateKey } = sodium.crypto_box_keypair();

      // Convert keys to a storable format (Base64)
      const publicKeyB64 = sodium.to_base64(publicKey, sodium.base64_variants.URLSAFE);
      const privateKeyB64 = sodium.to_base64(privateKey, sodium.base64_variants.URLSAFE);

      // Register user with public key
      const serverUrl = process.env.REACT_APP_SERVER_URL || 'https://connect-server-nfxv.onrender.com';
      await axios.post(`${serverUrl}/api/register`, {
        username,
        password,
        publicKey: publicKeyB64,
      });

      // Store private key in local storage **for this user**
      // In a real app, you'd want a more secure way to manage keys per user on a device
      localStorage.setItem(`privateKey_${username}`, privateKeyB64);

      navigate('/login');
    } catch (err) {
      setError('Username already exists or server error.');
      console.error('Registration failed:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleSubmit} className="auth-form">
        <h2>Register</h2>
        {error && <p className="error-message">{error}</p>}
        <div className="form-group">
          <label>Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Registering...' : 'Register'}
        </button>
        <p className="switch-form">
          Already have an account? <Link to="/login">Login here</Link>
        </p>
      </form>
    </div>
  );
};

export default Register;
